import React, { useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import LoadingSpinner from './components/LoadingSpinner';
import { useAuth } from './hooks/useAuth';

const App = () => {
  const { user, isAdmin, userName, loading, authChecked, handleLogout } = useAuth();
  
  useEffect(() => {
    // Change the title
    document.title = 'Berlin Home';
  }, []);

  if (!authChecked) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Login />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Dashboard isAdmin={isAdmin} user={user} userName={userName} onLogout={handleLogout} />
      )}
    </div>
  );
};

export default App;